import DOMPurify from 'dompurify';
import { getParams } from './params.js';

/**
 * Make sure that checkboxes and search have value if parameters found on load.
 * @param  {string} block the block id.
 */
const setInputs = (block) => {
	// Get saved params.
	const params = getParams(block);
	const inputs = block.querySelectorAll('input');

	// Array of parameters that are not taxonomies or search.
	const excludedParams = [
		'block',
		'paged',
		'orderby',
		'order',
		'pagination',
		'post_type',
		'relation',
	];

	inputs.forEach((input) => {
		if (input.type === 'checkbox') {
			input.checked = false;
		} else {
			input.value = '';
		}
	});

	// Loop through parameters and set values.
	Object.keys(params).forEach((k) => {
		if (excludedParams.indexOf(k) !== -1) {
			return;
		}

		// If search set search value.
		const input = block.querySelector(`[name="${k}"]`);

		if (input) {
			input.value = DOMPurify.sanitize(params[k]); // Sanitize the parameter value
		} else {
			// Set checkbox values.
			let terms = params[k];
			terms = Array.isArray(terms) ? terms : terms.split(',');
			terms.forEach((term) => {
				term = DOMPurify.sanitize(term); // Sanitize the term value
				const checkbox = block.querySelector(`[name="${k}_${term}"]`);
				if (checkbox) {
					checkbox.checked = true;
				}
			});
		}
	});
};

export default setInputs;
